import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { StockService } from './stock.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService, StockItem } from 'src/app/core';

type PrintUpdateType = Pick<StockItem, 'amount' | 'name' | 'price' | 'data'>;

@Injectable({ providedIn: 'root' })
export class TypingsService extends StockService {
  constructor(http: HttpClient, configService: ConfigService) {
    super(http, configService);
  }

  getAll(): Observable<StockItem[]> {
    return this.all();
  }

  /**
   * Update Binding
   * Just not implemented for now.
   */
  update(id: string, binding: PrintUpdateType) {}

  /**
   * Delete binding you want
   * Just not implemented for now.
   */
  delete() {}
}
